export default __webpack_public_path__ + "static/media/YAS0780.34I-35632_-25380_0.6ee0ea88.jpg";